<template>
  <div class="flex gap-2 items-start">
    <!-- Sol liste (kaynak) -->
    <div class="flex-1 border rounded overflow-hidden">
      <slot name="sourceheader">
        <div class="flex items-center justify-center gap-2 p-2 rounded-t-lg zemin-bilgi">
          <span class="text-sm font-semibold">Kaynak</span>
        </div>
      </slot>
      <div class="max-h-64 overflow-y-auto p-1">
        <div
          v-for="item in sourceItems"
          :key="item[dataKey]"
          :class="[
            'p-2 cursor-pointer hover:bg-gray-100 rounded text-sm',
            isSelectedSource(item) ? 'zemin-bilgi' : ''
          ]"
          @click="toggleSource(item)"
        >
          <slot name="option" :option="item">{{ item }}</slot>
        </div>
        <div v-if="!sourceItems.length" class="p-4 text-center text-gray-400 text-sm">
          Boş
        </div>
      </div>
    </div>

    <!-- Transfer butonları -->
    <div class="flex flex-col gap-1 justify-center pt-8">
      <Button
        text
        :disabled="!selectedSource.length"
        @click="moveToTarget"
      ><i class="pi pi-angle-right"></i></Button>
      <Button
        text
        :disabled="!selectedTarget.length"
        @click="moveToSource"
      ><i class="pi pi-angle-left"></i></Button>
      <Button
        text
        :disabled="!sourceItems.length"
        @click="moveAllToTarget"
      ><i class="pi pi-angle-double-right"></i></Button>
      <Button
        text
        :disabled="!targetItems.length"
        @click="moveAllToSource"
      ><i class="pi pi-angle-double-left"></i></Button>
    </div>

    <!-- Sağ liste (hedef) -->
    <div class="flex-1 border rounded overflow-hidden">
      <slot name="targetheader">
        <div class="flex items-center justify-center gap-2 p-2 rounded-t-lg zemin-olumlu">
          <span class="text-sm font-semibold">Hedef</span>
        </div>
      </slot>
      <div class="max-h-64 overflow-y-auto p-1">
        <div
          v-for="item in targetItems"
          :key="item[dataKey]"
          :class="[
            'p-2 cursor-pointer hover:bg-gray-100 rounded text-sm',
            isSelectedTarget(item) ? 'zemin-olumlu' : ''
          ]"
          @click="toggleTarget(item)"
        >
          <slot name="option" :option="item">{{ item }}</slot>
        </div>
        <div v-if="!targetItems.length" class="p-4 text-center text-gray-400 text-sm">
          Boş
        </div>
      </div>
      <!-- Target sıralama butonları -->
      <div v-if="showTargetControls" class="flex justify-center gap-1 p-1 border-t">
        <Button
          text
          :disabled="selectedTargetIndex <= 0"
          @click="moveTargetUp"
        ><i class="pi pi-angle-up"></i></Button>
        <Button
          text
          :disabled="selectedTargetIndex < 0 || selectedTargetIndex >= targetItems.length - 1"
          @click="moveTargetDown"
        ><i class="pi pi-angle-down"></i></Button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Array,
      default: () => [[], []],
      validator(val) {
        return Array.isArray(val) && val.length === 2 && Array.isArray(val[0]) && Array.isArray(val[1]);
      }
    },
    dataKey: {
      type: String,
      default: 'id'
    },
    showSourceControls: {
      type: Boolean,
      default: false
    },
    showTargetControls: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedSource: [],
      selectedTarget: []
    };
  },
  computed: {
    sourceItems() {
      return this.modelValue[0] || [];
    },
    targetItems() {
      return this.modelValue[1] || [];
    },
    selectedTargetIndex() {
      if (!this.selectedTarget.length) return -1;
      return this.targetItems.findIndex(t => t[this.dataKey] === this.selectedTarget[0][this.dataKey]);
    }
  },
  methods: {
    isSelectedSource(item) {
      return this.selectedSource.some(s => s[this.dataKey] === item[this.dataKey]);
    },
    isSelectedTarget(item) {
      return this.selectedTarget.some(t => t[this.dataKey] === item[this.dataKey]);
    },
    toggleSource(item) {
      const idx = this.selectedSource.findIndex(s => s[this.dataKey] === item[this.dataKey]);
      if (idx >= 0) {
        this.selectedSource.splice(idx, 1);
      } else {
        this.selectedSource.push(item);
      }
    },
    toggleTarget(item) {
      const idx = this.selectedTarget.findIndex(t => t[this.dataKey] === item[this.dataKey]);
      if (idx >= 0) {
        this.selectedTarget.splice(idx, 1);
      } else {
        this.selectedTarget.push(item);
      }
    },
    moveToTarget() {
      const newSource = this.sourceItems.filter(s => !this.isSelectedSource(s));
      const newTarget = [...this.targetItems, ...this.selectedSource];
      this.$emit('update:modelValue', [newSource, newTarget]);
      this.selectedSource = [];
    },
    moveToSource() {
      const newTarget = this.targetItems.filter(t => !this.isSelectedTarget(t));
      const newSource = [...this.sourceItems, ...this.selectedTarget];
      this.$emit('update:modelValue', [newSource, newTarget]);
      this.selectedTarget = [];
    },
    moveAllToTarget() {
      const newTarget = [...this.targetItems, ...this.sourceItems];
      this.$emit('update:modelValue', [[], newTarget]);
      this.selectedSource = [];
    },
    moveAllToSource() {
      const newSource = [...this.sourceItems, ...this.targetItems];
      this.$emit('update:modelValue', [newSource, []]);
      this.selectedTarget = [];
    },
    moveTargetUp() {
      const idx = this.selectedTargetIndex;
      if (idx <= 0) return;
      const newTarget = [...this.targetItems];
      [newTarget[idx - 1], newTarget[idx]] = [newTarget[idx], newTarget[idx - 1]];
      this.$emit('update:modelValue', [this.sourceItems, newTarget]);
    },
    moveTargetDown() {
      const idx = this.selectedTargetIndex;
      if (idx < 0 || idx >= this.targetItems.length - 1) return;
      const newTarget = [...this.targetItems];
      [newTarget[idx], newTarget[idx + 1]] = [newTarget[idx + 1], newTarget[idx]];
      this.$emit('update:modelValue', [this.sourceItems, newTarget]);
    }
  }
};
</script>
